export default "__VITE_ASSET__2fc19e4a__"